import React from 'react';
import { Link } from 'react-router-dom'; // For navigation
import "./Faculty.css";
import FacultyDetails from './FacultyDetails';

const Faculty = () => {
  const facultyList = [
    {
      path: "reena-kaushik",
      name: "Ms. Reena Kaushik",
      designation: "Principal",
      image: "/facultyimage/WhatsApp Image 2025-02-12 at 10.31.59.jpeg", 
    },
    {
      path: "divya-kaushik",
      name: "Ms. Divya Kaushik",
      designation: "HOD, Assistant Professor",
      image: "/facultyimage/School of pharmacy .jpg", 
    },
    {
      path: "brijesh",
      name: "Mr. Brijesh",
      designation: "Lecturer",
      image: "/facultyimage/WhatsApp Image 2025-02-19 at 13.36.37.jpeg", 
    },
    {
      path: "pragati-singh",
      name: "Ms. Pragati Singh",
      designation: "Lecturer",
      image: "/facultyimage/Screenshot_20250219-132728.png "

    },
    {
      path: "mohan-shyam",
      name: "Mr. Mohan Shyam",
      designation: "Lecturer",
      image: "../../public/facultyimage/mohan-shyam.jpeg",
    }
  ];

  return (
    <div className='main-container-faculty'>
      <div className='container-faculty'>
        <h1>Faculty</h1>

        {facultyList.map((faculty, index) => (
          <div className='card' key={index}>
            <Link to={`/FacultyDetails/${faculty.path}`}>
              <div className="bg"></div>
              <div className="blob"></div>
              <img 
                src={faculty.image}  // Use the faculty-specific image
                className='facultyimage1' 
                alt={faculty.name} 
              />
              <h3>{faculty.name}</h3>
              <p>{faculty.designation}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Faculty;

